import { useContext } from 'react';
import { HistoricalCtx, HistoricalCtxData } from './context';
import { ILog } from './model';
import { IHistoricalDefault } from './defaults';
import { CallStatusDefault } from '../../models';

const useHistorical = <T extends ILog>() => {
  const {
    historical = IHistoricalDefault<T>(),
    getLatestLogs,
    getMoreLogs,
    onRemoveLog
  }: HistoricalCtxData<T> = useContext(HistoricalCtx);

  const hasAllLogs = () => historical.logs.length === historical.total;

  return {
    logs: historical.logs || [],
    getLatestLogs: getLatestLogs,
    latestStatus: historical.latestStatus || CallStatusDefault,
    getMoreLogs: getMoreLogs,
    moreStatus: historical.moreStatus || CallStatusDefault,
    hasAllLogs,
    onRemoveLog
  };
};

export default useHistorical;
